import { render, staticRenderFns } from "./vm-facebook.vue?vue&type=template&id=63a1d40c&scoped=true&lang=pug&"
import script from "./vm-facebook.vue?vue&type=script&lang=js&"
export * from "./vm-facebook.vue?vue&type=script&lang=js&"
import style0 from "./vm-facebook.vue?vue&type=style&index=0&id=63a1d40c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a1d40c",
  null
  
)

export default component.exports